import useGetQuery from '_api/queries/useGetQuery';
import { Message } from '_api/types';

import { UseGetAllPageSizeProps } from '../types';

export const GET_MESSAGE_WITH = 'get-message-with';

export const useGetMessageWith = (
  id: number | undefined,
  { page = 0, size = 1000 }: UseGetAllPageSizeProps = {},
) =>
  useGetQuery<Message[]>(
    () => `/message/with/${id}?page=${page}&size=${size}`,
    {},
    [GET_MESSAGE_WITH],
    {
      enabled: typeof id === 'number',
      refetchOnWindowFocus: false,
    },
  );
